var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, Dropdown, InputRichText, InputText, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback, useContext, useMemo, useRef, useState, } from 'react';
import { v4 as uuid } from 'uuid';
/** A toolbar menu to enable selection of emendable variables in the editor */
export const FlowVariableSelector = (_a) => {
    var { className, variables, children, withSearch = variables.length > 10 } = _a, otherProps = __rest(_a, ["className", "variables", "children", "withSearch"]);
    const inputRef = useRef(null);
    const [isDropDownOpen, setIsDropDownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const { content: editorContent, window: editorWindow } = useContext(InputRichText.Context);
    const handleSelect = useCallback((variable) => {
        const variableNode = editorWindow.document.createTextNode(`{{${variable.key}}}`);
        editorContent.insert(variableNode);
        setIsDropDownOpen(false);
    }, [editorContent, editorWindow.document]);
    const filteredItems = useMemo(() => {
        return variables
            .filter(({ searchableName }) => variableLabelContainsSearchPhrase(searchableName, searchTerm))
            .map(variableToSelectorItem);
    }, [variables, searchTerm]);
    const handleSearchChange = useCallback((event) => {
        setSearchTerm(event.target.value);
    }, []);
    const toggleDropdown = useCallback((event) => {
        var _a;
        event.stopPropagation();
        setIsDropDownOpen((isOpen) => !isOpen);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const rootClass = classnames(className);
    return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [_jsx("div", Object.assign({ onClick: toggleDropdown }, { children: _jsx(InputRichText.ToolbarButton, { icon: "dropdown-list" }) })), _jsxs(Dropdown, Object.assign({ fixed: true, isOpen: isDropDownOpen, onClose: () => setIsDropDownOpen(false) }, { children: [withSearch && (_jsx(InputText, { ref: inputRef, value: searchTerm, onChange: handleSearchChange, placeholder: "Search...", icon: "search" })), _jsx(ButtonList, { children: filteredItems.map((item) => (_jsx(ButtonList.Item, Object.assign({ onClick: () => handleSelect(item), buttonProps: { type: 'button' } }, { children: item.label }), item.id))) })] }))] })));
};
function variableToSelectorItem(variable) {
    return Object.assign(Object.assign({}, variable), { key: variable.key, id: typeof variable.key === 'string' ? variable.key : uuid(), name: variable.searchableName });
}
function variableLabelContainsSearchPhrase(variableLabel, search = '') {
    return ((variableLabel === null || variableLabel === void 0 ? void 0 : variableLabel.toLocaleLowerCase().indexOf(search.toLocaleLowerCase())) !==
        -1);
}
